import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function KitchenHoodIcon(props) {
	return (
		<IconBase type="kitchen-hood" {...props}>
			<path d="M10.5 9V3H13.5V9H10.5Z" />
			<path d="M15 9.5L19 13.5H5L9 9.5H15Z" />
			<path d="M20 14H4V16H20V14Z" />
			<path d="M11.1252 20.6H10.5132C10.7493 19.678 10.406 19.346 10.2236 19.1696L10.2232 19.1692C10.211 19.1575 10.1996 19.1465 10.1892 19.136C9.57718 18.476 9.39718 17.804 9.55318 17H10.1532C10.0033 17.8764 10.1747 18.0879 10.4545 18.4332L10.4892 18.476C11.2808 19.4094 11.2348 19.7611 11.1301 20.5621L11.1252 20.6Z" />
			<path d="M12.3131 20.6H12.9251L12.9301 20.5621C13.0347 19.7611 13.0807 19.4094 12.2891 18.476L12.2544 18.4332C11.9746 18.0879 11.8032 17.8764 11.9531 17H11.3531C11.1971 17.804 11.3771 18.476 11.9891 19.136C11.9997 19.1466 12.0112 19.1577 12.0235 19.1696C12.2059 19.346 12.5492 19.678 12.3131 20.6Z" />
			<path d="M14.7252 20.6H14.1132C14.3493 19.678 14.0059 19.346 13.8235 19.1696C13.8113 19.1577 13.7997 19.1466 13.7892 19.136C13.1772 18.476 12.9972 17.804 13.1532 17H13.7532C13.6008 17.8909 13.7805 18.1062 14.0685 18.4513C14.0753 18.4594 14.0822 18.4677 14.0892 18.476C14.8808 19.4094 14.8348 19.7611 14.7301 20.5621C14.7285 20.5746 14.7268 20.5872 14.7252 20.6Z" />
		</IconBase>
	);
}
KitchenHoodIcon.propTypes = iconPropTypes;
